import React from "react";

/**
 * 미리보기 텍스트의 '전체 결과에서는 이런 걸 봐요' 목록을 눈에 띄게 그린다.
 *
 * 백엔드(client.py·quick.py)가 만드는 미리보기는
 *   [성향 설명] ───────── [안내 문장] · 항목 — 설명 …
 * 형태다. 성향 설명은 흐림 처리로 궁금증을 남기고, 항목 목록은 흐리지 않게
 * 카드로 뽑아 보여준다(흐림에 묻히면 결제 유도가 안 됨).
 */
const DIVIDER = "─────────────────────";

export function splitPreview(text: string) {
  const [head, tail = ""] = (text || "").split(DIVIDER);
  const lines = tail.split("\n").map(l => l.trim()).filter(Boolean);
  return {
    head: (head || "").trim(),
    intro: lines.find(l => !l.startsWith("·")) || "",
    items: lines.filter(l => l.startsWith("·")).map(l => l.replace(/^·\s*/, "")),
  };
}

export function PreviewHighlights(
  { intro, items, color }: { intro: string; items: string[]; color: string },
) {
  if (!items.length) return null;
  return (
    <div style={{
      marginTop: 14,
      background: `${color}0F`,
      border: `2px solid ${color}`,
      borderRadius: 16,
      padding: "16px 16px 14px",
      textAlign: "left",
    }}>
      {intro && (
        <div style={{
          fontSize: "0.95rem", fontWeight: 900, color,
          marginBottom: 10, letterSpacing: "-0.02em",
        }}>
          {intro}
        </div>
      )}
      {items.map((it, i) => {
        const [title, ...rest] = it.split("—");
        return (
          <div key={i} style={{
            display: "flex", alignItems: "flex-start", gap: 8,
            padding: "7px 0",
            borderTop: i === 0 ? "none" : `1px solid ${color}22`,
          }}>
            <span style={{
              flexShrink: 0, width: 20, height: 20, borderRadius: "50%",
              background: color, color: "#fff",
              fontSize: 12, fontWeight: 900, lineHeight: "20px",
              textAlign: "center", marginTop: 1,
            }}>✓</span>
            <div style={{ fontSize: "0.88rem", lineHeight: 1.55 }}>
              <span style={{ fontWeight: 800, color: "#2B2A26" }}>{title.trim()}</span>
              {rest.length > 0 && (
                <span style={{ color: "#7A7266" }}> — {rest.join("—").trim()}</span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
